import { Box, Card, CardContent, Typography } from '@mui/material';

import GreenCheckmarkFilled from '../../../images/green-checkmark-filled.svg';

export const AIOOutcomeSuccessCard = () => (
  <Card
    elevation={1}
    sx={{
      borderRadius: 5,
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.02)',
      width: '100%',
      maxWidth: { xs: '100%', sm: 500, md: 666 },
      minHeight: 400,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <CardContent
      sx={{
        p: { xs: 3, sm: 4, md: 5 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 5,
        textAlign: 'center',
      }}
    >
      {/* Success Icon */}
      <Box
        sx={{
          width: 140,
          height: 140,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src={GreenCheckmarkFilled}
          alt="Success"
          width="140"
          height="140"
        />
      </Box>

      {/* Success Text */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
        <Typography
          sx={{
            color: 'black',
            fontSize: 32,
            fontFamily: 'DM Sans',
            fontWeight: '700',
            lineHeight: '38.40px',
            textAlign: 'center',
          }}
        >
          Call outcome has been submitted
        </Typography>
        <Typography
          sx={{
            color: 'black',
            fontSize: 16,
            fontFamily: 'DM Sans',
            fontWeight: '500',
            lineHeight: '22.40px',
            textAlign: 'center',
          }}
        >
          You may close this tab or window
        </Typography>
      </Box>
    </CardContent>
  </Card>
);
